var _this = this;
import * as tslib_1 from "tslib";
import createMailboxExportRequest from '../services/createMailboxExportRequest';
import { orchestrator } from 'satcheljs';
import setIsExportMailboxRequestMade from '../mutators/setIsExportMailboxRequestMade';
import requestMailboxExport from '../actions/requestMailboxExport';
import getStore from '../store/store';
import deleteMailboxExportRequest from '../services/deleteMailboxExportRequest';
import setExportLink from '../mutators/setExportLink';
import setExportStatus from '../mutators/setExportStatus';
export default orchestrator(requestMailboxExport, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                setIsExportMailboxRequestMade(true);
                if (!getStore().downloadLink) return [3 /*break*/, 2];
                // The user is requesting a re-export, so we need to delete the previous request.
                setExportLink(undefined);
                setExportStatus(undefined);
                return [4 /*yield*/, deleteMailboxExportRequest()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, createMailboxExportRequest()];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=requestMailboxExport.js.map